import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import 'chart.js/auto';

function ProductCard({ product }) {
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US"); // format as MM/DD/YYYY
  };

  // prep price data for the chart
  const chartData = {
    labels: product.prices.map((price) => formatDate(price.timestamp)), // dates as labels
    datasets: [
      {
        label: `Price History`,
        data: product.prices.map((price) => {
          return price.amount;
        }),
        borderColor: "rgba(75,192,192,1)",
        fill: false,
      },
    ],
  };

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="h6">{product.name}</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Stock: {product.stock}
        </Typography>
        <Typography variant="body2" color="primary" sx={{ mb: 2 }}>
          <a
            href={product.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            BUY HERE
          </a>
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Price Changes: {product.price_change}
        </Typography>
        <Line data={chartData} />
      </CardContent>
    </Card>
  );
}

export default ProductCard;